import WorkGallery from "../../../../src/layouts/WorkGallery";
import React from 'react';
export default {
  WorkGallery,
  React
};